import { Navigate } from 'react-router'
import { useLocation } from 'src/utils/router/route'

const NotLogin = () => {
  const location = useLocation()
  const fullPath = location.pathname + location.search + location.hash

  const to = `/login?to=${fullPath}`

  return <Navigate to={to} replace />
}

export default NotLogin
